"use client";

import NotFoundScreen from "screens/NotFoundScreen";

export default function GlobalError() {
  return <NotFoundScreen />;
}
